const PIXEL_ID = '1343241747689250'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

function loadPixelScript() {
  if (window.fbq) return

  const n: any = (window.fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)
}

export function initPixel() {
  loadPixelScript()
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart(productName: string, value: number) {
  window.fbq('track', 'AddToCart', {
    content_name: productName,
    content_type: 'product',
    value: value,
    currency: 'USD',
  })
}
